import { BasePage } from "@Tenants/Jm/Site/BasePage";
import { BaseCategory } from "@Base/Category/Category";
import { ContentService } from "@Api/ContentService";
import { Fancyapps } from "@Libraries/Fancyapps";
import type { Fancybox } from '@fancyapps/ui';
import { HeaderBase } from "@Base/Site/HeaderBase";

import "./Category.scss";

export class Category extends BaseCategory
{
	private QuickShopLinks: NodeListOf<HTMLElement>;
	private QuickShopModal: Fancybox;

	constructor()
	{
		super();
	}

	public Initialize(): void
	{
		super.Initialize();

		this.QuickShopLinks = document.querySelectorAll(".quickShop");

		if (document.querySelector("#filterContent") !== null)
		{
			this.ConfigureSidebar();
		}

		if (this.QuickShopLinks.length > 0)
		{
			this.ConfigureQuickShopLinks();
		}
	};

	public ConfigureQuickShopLinks(): void
	{
		const messageHandler = this.QuickShopClose.bind(this);
		const openHandler = this.QuickShopHandler.bind(this);

		window.addEventListener("message", messageHandler);

		this.QuickShopLinks.forEach((link: HTMLElement) =>
		{
			link.addEventListener("click", openHandler);
		});
	};

	public async QuickShopClose(e: MessageEvent): Promise<void>
	{
		if (e.data === "quickShopClose")
		{
			this.QuickShopModal.close();
		}
		else if (e.data === "quickShopUpdate")
		{
			const contentService = new ContentService();
			const header = new HeaderBase();
			contentService.ApiCall().then(() =>
			{
				if (typeof ContentService !== "undefined" && typeof ContentService.Response !== "undefined")
				{
					// Reinitialize the transit banner with the new shipping information
					header.UpdateCartIcon();
				};
			});
		}
	}

	public async QuickShopHandler(e: Event): Promise<void>
	{
		e.preventDefault();

		if (e.target instanceof Element)
		{
			const id = e.target.closest(".ps-item").parentElement.getAttribute("data-product-id");
			const href = `/product/quickshop/${id}`;
			const fancyapps = await Fancyapps.Import();
			const fancybox = fancyapps.Fancybox;
			this.QuickShopModal = new fancybox([
				{
					src: href,
					type: "iframe"
				}
			], {
				mainClass: "quickShopModal"
			});
		}
	};
}

export class CategoryPage extends BasePage
{
	public Category: Category;
	constructor()
	{
		super();
		this.Initialize();
	}

	public async Initialize(): Promise<void>
	{
		super.Initialize();
		this.Category = new Category();
	};
}

const category = new CategoryPage();